var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmationPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 23,
    fill: "white",
    stroke: "white",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9997 4C14.0397 4 4.33301 13.7067 4.33301 25.6667C4.33301 37.6267 14.0397 47.3333 25.9997 47.3333C37.9597 47.3333 47.6663 37.6267 47.6663 25.6667C47.6663 13.7067 37.9597 4 25.9997 4ZM25.9997 43C16.4447 43 8.66634 35.2217 8.66634 25.6667C8.66634 16.1117 16.4447 8.33334 25.9997 8.33334C35.5547 8.33334 43.333 16.1117 43.333 25.6667C43.333 35.2217 35.5547 43 25.9997 43ZM35.9447 16.09L21.6663 30.3683L16.0547 24.7783L12.9997 27.8333L21.6663 36.5L38.9997 19.1667L35.9447 16.09Z",
    fill: "#26BB9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationPayment);
export default __webpack_public_path__ + "static/media/confirmationPayment.87bc782442acb4bad75e0415aa831d7b.svg";
export { ForwardRef as ReactComponent };